var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board"},[_c('InfoBox',{attrs:{"title":_vm.title}},_vm._l((_vm.messages),function(message){return _c('Message',{key:message.title,attrs:{"message":message}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }